import { render, staticRenderFns } from "./seat.vue?vue&type=template&id=648b8198&"
import script from "./seat.vue?vue&type=script&lang=js&"
export * from "./seat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports